import { render, staticRenderFns } from "./foreUPProduct.vue?vue&type=template&id=161da760&scoped=true"
import script from "./foreUPProduct.vue?vue&type=script&lang=js"
export * from "./foreUPProduct.vue?vue&type=script&lang=js"
import style0 from "./foreUPProduct.vue?vue&type=style&index=0&id=161da760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161da760",
  null
  
)

export default component.exports